// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__37eEw","slider":"styles_slider__lOmZv","checkbox":"styles_checkbox__3aZry","round":"styles_round__PUMjG"};